import React, { Fragment, useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footertwo';
import Content from '../sections/homethree/Content';
import { fetchAgents, fetchRecentProperties } from '../../api/api';

const Homethree = () => {
  const [properties, setProperties] = useState([]);
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    fetchRecentProperties()
      .then((data) => {
        setProperties(data.searchResults);
      })
      .catch((err) => {});

    fetchAgents()
      .then((data) => {
        setAgents(data);
      })
      .catch((err) => {});
  }, []);

  return (
    <Fragment>
      <MetaTags>
        <title>iProLand Real Estate | Homepage</title>
      </MetaTags>
      <Header />
      <Content recentProperties={properties} agents={agents}/>
      <Footer />
    </Fragment>
  );
};

export default Homethree;
